import {ChangeDetectorRef, Component, Inject, OnInit} from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import  dayjs from 'dayjs';
import { catchError, throwError } from 'rxjs';
import { DateRangeModel } from 'src/app/models/date-range-selection-models/date-range-model';
import { PinType } from 'src/app/models/pinType';
import { NavBarComponent } from 'src/app/nav-bar/nav-bar.component';
import { PinManagerService } from 'src/app/services/pin-manager.service';
import {PIN_ICONS} from "../new-save-pin/new-save-pin.component";

@Component({
    selector: 'app-view-saved-pin',
    templateUrl: './view-saved-pin.component.html',
    styleUrls: ['./view-saved-pin.component.css'],
    standalone: false
})
export class ViewSavedPinComponent implements OnInit {
  viewSavedPinForm: FormGroup;
  pinTypesList = [];
  pinType: PinType;
  excludedId:number = 9; //N tester pin Id
  isCustomRange: boolean = false;
  dateStringFormatting = 'YYYY.DD.MM';
  // filterStartDate = new FormControl(null);
  // filterEndDate  = new FormControl(null);

  filterStartDate = new FormControl(null);
  filterEndDate  = new FormControl(null);
  // viewSavedPinForm: FormGroup;

  selectedateRange?: DateRangeModel = null;

  currentDate = dayjs().format('YYYY-MM-DD');

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
      public nav: NavBarComponent,
      private fb: FormBuilder,
      private pinManagerService: PinManagerService,
      public viewSavedPin: MatDialogRef<ViewSavedPinComponent>,
      public dialog: MatDialog,
      private cd: ChangeDetectorRef
  ) {
    this.viewSavedPinForm = this.fb.group({
      pinType: new FormControl({}),
      filterStartDate:new FormControl(null, Validators.required),
      filterEndDate:  new FormControl(null, Validators.required),
    });

  //   this.viewSavedPinForm = this.fb.group({
  //   filterStartDate:new FormControl(null, Validators.required),
  //   filterEndDate:  new FormControl(null, Validators.required),
  // });


  }
  ngOnInit(): void {
     this.populatePinTypesListDropDown();
     const defaultStartDate = dayjs().subtract(90, 'day').format('YYYY-MM-DD');
     const defaultEndDate = dayjs().format('YYYY-MM-DD');
     this.viewSavedPinForm.controls.filterStartDate.setValue(defaultStartDate);
     this.viewSavedPinForm.controls.filterEndDate.setValue(defaultEndDate);
    }

    populatePinTypesListDropDown() {
      this.pinManagerService.getPinTypesList().pipe(
              catchError((error) => {
                console.error(error);
                return throwError(() => error);
              })
          )
          .subscribe((response) => {
            this.pinTypesList = response;

            this.pinType = {
              id: null,
              name: 'All',
              dateModified: ' '
            }
  
            this.pinTypesList.unshift(this.pinType);
            
            this.viewSavedPinForm.controls.pinType.setValue(this.pinType);

            if (document?.title === 'SGS Precision Gateway') {
              this.pinTypesList = this.pinTypesList.filter(item => item.id !== this.excludedId);
            }
           

          });
    }

    setSelectedPinType(pinType: any) {
      // console.log(pinType)
      this.pinType = pinType.value;
    }
  
    cancel(){
      this.viewSavedPin.close({"option": "cancel"});
    }
    clear(){
      this.viewSavedPin.close({"option": "clear"});
    }
  
    apply() {
      let applyObj = {
            selectecPinType: this.viewSavedPinForm.controls.pinType.value,
            option: "apply",
            filterStartDate: dayjs(this.viewSavedPinForm?.controls?.filterStartDate?.value).format('YYYY-MM-DD'),
            filterEndDate: dayjs(this.viewSavedPinForm?.controls?.filterEndDate?.value).format('YYYY-MM-DD')
          }
        this.viewSavedPin.close({applyObj});
    }


      setFilterDates(){
        if(this.viewSavedPinForm?.controls?.filterStartDate?.value && this.viewSavedPinForm?.controls?.filterEndDate?.value){
            this.viewSavedPinForm = this.fb.group({
                filterStartDate: dayjs(this.viewSavedPinForm?.controls?.filterStartDate.value).format('YYYY-MM-DD'),
                filterEndDate: dayjs(this.viewSavedPinForm?.controls?.filterEndDate.value).format('YYYY-MM-DD')
            });
        }
    }
    handlePeriodSelection(period: DateRangeModel) {

      if(period.description === "Custom"){
        this.isCustomRange = true;  // show date inputs
        this.viewSavedPinForm.controls.filterStartDate.setValue(period.period);
        this.viewSavedPinForm.controls.filterEndDate.setValue(this.currentDate);
         this.cd.detectChanges();
      }else{
        this.isCustomRange = false; // hide date inputs
        this.viewSavedPinForm.controls.filterStartDate.setValue(period.period);
        this.viewSavedPinForm.controls.filterEndDate.setValue(this.currentDate);
      }

    }

    protected readonly pinIcons = PIN_ICONS;
}
